// Reference: https://stackoverflow.com/questions/1026069/how-do-i-make-the-first-letter-of-a-string-uppercase-in-javascript
// ** IMPORTANT **: Keep in sync with functions/src/index.ts
const capitalizeFirstLetter = (str: string): string => {
    const lowercaseStr = str.toLowerCase();
    return lowercaseStr.charAt(0).toUpperCase() + lowercaseStr.slice(1);
};

export default capitalizeFirstLetter;
